import { captureSignupAttribution } from './attribution.js';

// Labels only: never send full referrer URLs, queries, or customer document paths.
export function captureVisitorAcquisition() {
  captureSignupAttribution();
  const params = new URLSearchParams(window.location.search);
  const read = (...names) => names.map(name => params.get(name)).find(Boolean) || '';
  let source = read('utm_source', 'utmSource');
  let medium = read('utm_medium', 'utmMedium');
  const naverAd = params.has('n_keyword') || params.has('n_media') || params.has('n_campaign_type');
  if (!source && naverAd) { source = 'naver'; medium = medium || 'cpc'; }
  let host = '';
  try { host = new URL(document.referrer).hostname; } catch { /* direct visit */ }
  const campaign = read('utm_campaign', 'utmCampaign');
  return { source: source.slice(0, 255), medium: medium.slice(0, 100),
    campaign: campaign.slice(0, 255), referrerHost: host,
    landingPath: window.location.pathname };
}
